import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 120000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?.url?.includes("/auth/")
    ) {
      localStorage.removeItem("token");
      if (
        window.location.pathname !== "/signin" &&
        window.location.pathname !== "/signup"
      ) {
        window.location.href = "/signin";
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Upload a file directly to S3 via presigned URL, bypassing the API Gateway 10 MB limit.
 *
 * 1. Requests a presigned PUT URL from the backend.
 * 2. PUTs the file directly to S3 using raw axios (no auth headers).
 * 3. Returns { s3_url, key } for subsequent backend calls.
 */
export async function presignedUpload(file) {
  // Step 1: get presigned URL from our backend
  const presignRes = await api.post("/upload/presign", null, {
    params: { filename: file.name, content_type: file.type },
  });
  const { presigned_url, s3_url, key } = presignRes.data;

  // Step 2: upload directly to S3 using raw axios (different domain, no auth headers)
  await axios.put(presigned_url, file, {
    headers: {
      "Content-Type": file.type,
      "x-amz-server-side-encryption": "AES256",
    },
    timeout: 600000, // 10 min timeout for large files
  });

  // Step 3: return the final S3 URL and key
  return { s3_url, key };
}

export default api;
